import { NavigationEnd, Router } from '@angular/router';
import { Component, OnInit, ViewEncapsulation, HostListener, AfterViewInit, ViewChild, ElementRef, ChangeDetectorRef, OnDestroy } from '@angular/core';

import { Observable } from 'rxjs';

import { FADE_IN_OUT_ANIMATION } from '@shared/animations';
import { PageService, OfferService, LanguageService, BannerService, ExpertiseService, ScriptService } from '@shared/services';
import { Page, Offer, Banner, BannerItem, Expertise, Language } from '@shared/data';

@Component({
  moduleId: 'module.id',
  selector: 'about-us',
  styles: [require('./about-us.component.scss')],
  template: require('./about-us.component.html'),
  animations: [FADE_IN_OUT_ANIMATION]
})
export class AboutUsComponent implements OnInit, AfterViewInit {
  public home: Observable<Page>;
  public page: Observable<Page>;
  public offers: Observable<Offer[]>;
  public lang: Observable<string>;
  public cfm: Observable<Map<string, any>>;

  constructor(
    private pageService: PageService,
    private offerService: OfferService,
    private languageService: LanguageService,
    private scriptService: ScriptService) {

  }

  public ngOnInit() {
    this.home = this.pageService.home();
    this.page = this.pageService.aboutUs();
    this.offers = this.offerService.allOffers();
    this.lang = this.languageService.getCurrentLang();

    this.cfm = this.lang.switchMap(lang => {
      return this.page.map(
        page => {
          let map = new Map<string, string>();

          page.customFields.forEach(o => {
            let v = o.value[lang] || o.value[Language.DEFAULT_LANG];

            map.set(o.key, v);
          });

          return map;
        }
      );
    });
  }

  public ngAfterViewInit() {

  }

  public onAfterChange() {

  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+web/modules/+about-us/about-us.component.ts